<template>
  <div>
    <Card>
      <ui-button
        text="Default style"
        icon="fas fa-times"
        button-style="default"
      ></ui-button>
    </Card>
    <Card>
      <ui-button
        text="Contained style"
        icon="fas fa-plus"
        button-style="contained"
      ></ui-button>
    </Card>
    <Card>
      <ui-button
        text="Simple style"
        icon="fas fa-plus"
        button-style="simple"
      ></ui-button>
    </Card>
    <Card>
      <ui-button
        text="Text style"
        icon="fas fa-plus"
        button-style="outline-alt"
      ></ui-button>
    </Card>
    <Card>
      <ui-button
        text="Red style"
        icon="fas fa-plus"
        button-style="red"
      ></ui-button>
    </Card>
    <Card>
      <ui-button
        text="Plain style"
        button-style="plain"
      ></ui-button>
    </Card>
    <Card>
      <ui-button
        text="Accent style"
        icon="fas fa-plus"
        button-style="accent"
      ></ui-button>
    </Card>
    <Card>
      <ui-button
        text="Blue style"
        button-style="blue"
      ></ui-button>
    </Card>
    <Card>
      <ui-button
        text="Outline-accent style"
        icon="fas fa-plus"
        button-style="outline-accent"
      ></ui-button>
    </Card>
    <Card>
      <ui-button
        text="Disabled"
        :disabled="true"
      ></ui-button>
    </Card>
    <Card>
      <ui-button
        text="Large"
        icon="fas fa-plus"
        size="large"
      ></ui-button>
    </Card>
    <Card>
      <ui-button
        text="Mini"
        icon="fas fa-check"
        size="mini"
        color="primary"
        :forceChevron="true"
      />
    </Card>
    <Card>
      <ui-button
        text="Micro"
        icon="fas fa-list"
        size="micro"
        button-style="accent"
      />
    </Card>
    <Card>
      <ui-button
        text="Menu List"
        icon="fas fa-check"
        color="primary"
        :forceChevron="true"
        :hasMenu="true"
        :menu-list="[menuList]"
      />
    </Card>
  </div>
</template>

<script setup lang="ts">
import Card from '@/stories/utils/card.vue';

const menuList = [
  {
    key: '1',
    title: 'test1',
    icon: 'far fa-pen',
  },
  {
    key: '2',
    title: 'test2',
    icon: 'far fa-pen',
  },
];
</script>
